import React from 'react'

function Success() {
    return(
        <h1>Sucesso</h1>
    )
}

export default Success